import React, { CSSProperties } from 'react';
import classes from './index.module.scss';

/**
 * Props interface for the Checkbox component
 * Extends HTML input attributes with custom properties
 */
interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
	/** Whether the checkbox is checked */
	checked: boolean;
	/** Optional label text to display next to the checkbox */
	label?: string;
	/** Optional styling for the label element */
	labelStyle?: CSSProperties;
}

/**
 * Checkbox component
 * Renders a styled checkbox input with optional label
 * Used for boolean selections in forms and data tables
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const Checkbox = ({ name, label, id, checked, className, labelStyle, onChange, ...props }: Props) => {
	return (
		<label style={labelStyle} className={classes['checkbox']} htmlFor={id}>
			{/* Checkbox input */}
			<input
				name={name}
				id={id}
				type="checkbox"
				checked={checked}
				onChange={onChange}
				className={className}
				{...props}
			/>
			{/* Optional label text */}
			{label}
		</label>
	);
};

export default Checkbox;
